import { h } from '@stencil/core';
import { SVGOpts } from '../../../common/images/icons-opts';

export const IconBackOrder = (opts?: SVGOpts) => (
  <svg
    class={opts?.class}
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.26562 1.04297C1.04688 0.824219 0.71875 0.988281 0.71875 1.26172V5.17188C0.71875 5.36328 0.855469 5.5 1.04688 5.5H4.95703C5.23047 5.5 5.39453 5.17188 5.17578 4.95312L3.69922 3.47656C4.65625 2.49219 5.99609 1.89062 7.5 1.89062C10.4531 1.89062 12.8594 4.29688 12.8594 7.25C12.8594 10.2305 10.4531 12.6094 7.5 12.6094C6.10547 12.6094 4.875 12.1172 3.91797 11.2695C3.78125 11.1602 3.58984 11.1602 3.48047 11.2695L2.93359 11.8164C2.79688 11.9531 2.79688 12.1719 2.93359 12.3086C4.13672 13.375 5.75 14.0312 7.5 14.0312C11.2188 14.0312 14.2539 11.0234 14.2812 7.27734C14.2812 3.53125 11.2188 0.46875 7.47266 0.46875C5.61328 0.46875 3.91797 1.23438 2.6875 2.46484L1.26562 1.04297Z"
      fill="#FF5C00"
    />
  </svg>
);
